import React, { useEffect, useState } from "react";
import BglessGirl from "../../../assets/images/Bgless-girl-cbr.svg";

interface CoreValue {
  id: number;
  name: string;
  icon: string;
}

interface AboutUsData {
  vision: string;
  //mission: string;
}

const STATIC_CORE_VALUES: CoreValue[] = [
  { id: 1, name: "Discipline", icon: "" },
  { id: 2, name: "Consistency", icon: "" },
  { id: 3, name: "Perseverance", icon: "" },
  { id: 4, name: "Diligence", icon: "" },
  { id: 5, name: "Early-rising", icon: "" },
  { id: 6, name: "Meditation", icon: "" },
];

const WhyWeExist: React.FC = () => {
  const [aboutData, setAboutData] = useState<AboutUsData | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Placeholder API call to fetch about us data
    const fetchAboutData = async () => {
      try {
        setIsLoading(true);
        const response = await fetch(
          `${process.env.REACT_APP_API_URL || ""}/api/vision`
        );

        if (response.ok) {
          const data = await response.json();
          setAboutData(data.data);
        } else {
          // Fallback data
          setAboutData({
            //vision: "",
            vision:
              "To empower believers with discipline that enables them to enjoy intimacy with Christ through feasting on His Word everyday in order to know the whole truth, grow in godliness and save themselves from increasing levels of deception today as we wait for His second coming.",
          });
        }
      } catch (error) {
        console.error("Error fetching about data:", error);
        // Fallback data on error
        setAboutData({
          //vision: "",
          vision:
            "To empower believers with discipline that enables them to enjoy intimacy with Christ through feasting on His Word everyday in order to know the whole truth, grow in godliness and save themselves from increasing levels of deception today as we wait for His second coming.",
        });
      } finally {
        setIsLoading(false);
      }
    };

    fetchAboutData();
  }, []);

  const getValueIcon = (name: string) => {
    // Placeholder icons - in real implementation, these would come from API
    const iconMap: Record<string, JSX.Element> = {
      Discipline: (
        <svg className="w-12 h-12" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
        </svg>
      ),
      Consistency: (
        <svg className="w-12 h-12" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
        </svg>
      ),
      Perseverance: (
        <svg className="w-12 h-12" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      ),
      Diligence: (
        <svg className="w-12 h-12" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      ),
      "Early-rising": (
        <svg className="w-12 h-12" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
        </svg>
      ),
      Meditation: (
        <svg className="w-12 h-12" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
        </svg>
      ),
    };
    return iconMap[name] || (
      <div className="w-12 h-12 border-2 border-lightBlue rounded-lg"></div>
    );
  };

  if (isLoading) {
    return (
      <div className="container mx-auto py-16 px-4">
        <div className="text-center">Loading...</div>
      </div>
    );
  }

  return (
    <div className="container mx-auto py-16 px-4">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-stretch">
        {/* Left side - Text content */}
        <div>
          <div className="mb-12">
            <p className="text-navYellow text-xl font-medium mb-2">Our Vision</p>
            <h2 className="text-3xl md:text-4xl font-medium text-darkBlue mb-6">
              Why we exist
            </h2>
            {aboutData && (
              <p className="text-gray-600 text-lg leading-relaxed">
                {aboutData.vision}
              </p>
            )}
          </div>

          {/* Core Values */}
          <div>
            <p className="text-navYellow text-xl font-medium mb-6">Core Values</p>
            <div className="grid grid-cols-3 gap-6">
              {STATIC_CORE_VALUES.map((value) => (
                <div
                  key={value.id}
                  className="flex flex-col items-center p-4 bg-white rounded-lg hover:shadow-md transition-shadow"
                >
                  <div className="text-lightBlue mb-3">
                    {getValueIcon(value.name)}
                  </div>
                  <p className="text-sm font-medium text-gray-700 text-center">
                    {value.name}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Right side - Image */}
        <div className="relative h-[400px] md:h-full md:max-h-full">
          <img
            src={BglessGirl}
            alt="Person studying Bible"
            className="w-full h-full max-h-[550px] object-contain rounded-lg"
          />
        </div>
      </div>
    </div>
  );
};

export default WhyWeExist;

